import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { InputStyle } from "@insite/mobius/TextField";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListLineStyles.productPriceStyles = mergeToNew(productListLineStyles.productPriceStyles, {
    priceLabelText: {
        color: "text.accent",
    },
});

productListLineStyles.productQuantityOrderedStyles = {
    labelProps: {
        css: css`
            @media print {
                font-size: 12px;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
                >${InputStyle}{
                    &:focus, &:focus-within{
                        border: 2px solid ${getColor("common.border")} !important;
                    }
                }
            `,
        inputSelect: css`
            @media print {
                width: 100px;
            }
        `,
    },
}

